import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  Menu,
  TextField,
} from '@mui/material';
import { useMemo } from 'react';

interface Option {
  label: string;
  id: number;
  value?: string;
}

const menuStyles = {
  '& .MuiPaper-root': {
    width: '400px',
    display: 'flex',
    flexDirection: 'column',
    padding: '12px',
    justifyContent: 'center',
    alignItems: 'center',
    ul: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
  },
};

interface HomeModelsGenericDropdownProps {
  title: string;
  open: boolean;
  disabled?: boolean;
  anchorEl: null | HTMLElement;
  handleChange: (event: string, keyToUpdate: string) => void;
  handleClose: () => void;
  handleClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  minValue: string;
  minKey: string;
  maxValue: string;
  maxKey: string;
  options: Option[];
  money?: boolean;
  mobile?: boolean;
}

export const HomeModelsGenericDropdown = ({
  title,
  open,
  disabled,
  anchorEl,
  handleChange,
  handleClick,
  handleClose,
  minValue,
  minKey,
  maxValue,
  maxKey,
  options,
}: HomeModelsGenericDropdownProps) => {
  const dropdownText = useMemo(() => {
    if (!minValue && !maxValue) {
      return title;
    } else if (minValue && !maxValue) {
      if (minValue === `No Min ${title}`) {
        return `No Min ${title}`;
      }
      return `More than ${minValue.toLocaleString()}`;
    } else if (maxValue && !minValue) {
      if (maxValue === `No Max ${title}`) {
        return `No Max ${title}`;
      }
      return `Less than ${maxValue.toLocaleString()}`;
    } else if (maxValue && minValue) {
      return `${minValue.toLocaleString()} - ${maxValue.toLocaleString()}`;
    }
  }, [maxValue, minValue, title]);

  return (
    <div className={`price-dropdown-container`}>
      <Button
        disabled={disabled}
        data-open-price-dropdown
        data-open-price-dropdown-has-value={minValue || maxValue ? true : false}
        id="open-price-dropdown-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        variant="filled"
        style={{ textTransform: 'uppercase' }}
      >
        {dropdownText}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={menuStyles}
        slotProps={{
          list: {
            'aria-labelledby': 'open-price-dropdown-button',
          },
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
          <Autocomplete
            fullWidth
            data-price-min-input
            freeSolo
            value={minValue}
            options={[{ label: `No Min ${title}`, id: -1 }, ...options]}
            onChange={(_event, newValue) => {
              if (typeof newValue === 'string') {
                handleChange(newValue, minKey);
              } else {
                handleChange(newValue ? newValue.label : '', minKey);
              }
            }}
            renderInput={(params) => (
              <TextField {...params} label={`Minimun ${title}`} />
            )}
          />
          <Box sx={{ margin: '12px' }} data-size-input-dash-container>
            <span data-size-input-dash>-</span>
          </Box>
          <Autocomplete
            fullWidth
            data-price-max-input
            freeSolo
            value={maxValue}
            options={[{ label: `No Max ${title}`, id: -1 }, ...options]}
            onChange={(_event, newValue) => {
              if (typeof newValue === 'string') {
                handleChange(newValue, maxKey);
              } else {
                handleChange(newValue ? newValue.label : '', maxKey);
              }
            }}
            renderInput={(params) => (
              <TextField {...params} label={`Maximum ${title}`} />
            )}
          />
        </Box>
        <FormControl
          className="mobile-search-apply-buttons"
          sx={{ m: 1, width: '100%' }}
          size="small"
        ></FormControl>
      </Menu>
    </div>
  );
};
